import React, { Fragment } from "react";
import Input from '../forms/Input';

export default (props) => {
  return (
    <Fragment>
      <Input value={props.title} label="عنوان صفحه" name="meta_title" type="text" />
      <Input value={props.keywords} maxLength={160} label="MetaKeywords" name="meta_keywords" type="textarea" />
      <Input value={props.description} maxLength={160} label="MetaDescription" name="meta_description" type="text" />
    </Fragment>
  );
};
